import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

// Import components
import Login from './components/auth/Login';
import LandingPage from './pages/LandingPage';
import CreatePrenup from './pages/CreatePrenup';
import MyPrenups from './pages/MyPrenups';
import PrenupDetails from './pages/PrenupDetails';
import MarriageIndex from './pages/MarriageIndex';
import VerifySheet from './pages/VerifySheet';
import PrintSheet from './pages/PrintSheet';
import Details from './pages/Details';
import ChangePassword from './pages/ChangePassword';
import Logout from './pages/Logout';
import ForgotPassword from './pages/ForgotPassword';
import AdvancedSearch from './pages/AdvancedSearch';
import NotFound from './pages/NotFound';

// Import styles
import './index.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/prenup/SystemUser/Login" element={<Login />} />
            <Route path="/prenup/SystemUser/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/prenup/PreMarriageSheet/VerifySheet" element={<VerifySheet />} />
            <Route path="/prenup/PreMarriageSheet/PrintSheet" element={<PrintSheet />} />
            <Route path="/prenup/PreMarriageSheet/Details" element={<Details />} />

            {/* Protected Routes */}
            <Route
              path="/prenup/PreMarriageSheet/Create"
              element={
                <ProtectedRoute>
                  <CreatePrenup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/prenup/PreMarriageSheet/MarriageIndex"
              element={
                <ProtectedRoute>
                  <ErrorBoundary>
                    <MarriageIndex />
                  </ErrorBoundary>
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-prenups"
              element={
                <ProtectedRoute>
                  <MyPrenups />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-prenups/:id"
              element={
                <ProtectedRoute>
                  <PrenupDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/prenup/SystemUser/ChangePassword"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/prenup/SystemUser/Logout"
              element={
                <ProtectedRoute>
                  <Logout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/advanced-search"
              element={
                <ProtectedRoute>
                  <AdvancedSearch />
                </ProtectedRoute>
              }
            />

            {/* 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
